import dayjs from 'dayjs';

const MIN_APPLY_TIME_BEFORE_EVENT = -30;

export function isEventApplicable(date: string) {
  return MIN_APPLY_TIME_BEFORE_EVENT < dayjs(date).diff(new Date(), 'm');
}
